module.exports = __webpack_public_path__ + "img/background30.b54a6117.jpg";